import ArbitrationAgreement from './arbitration_agreement';
export default ArbitrationAgreement;
